export default __webpack_public_path__ + "static/media/arrow-down.62cd43fe.svg";